import { useCallback, useState, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import useScrollToTop from '@/hooks/UseScrollToTop';
import styles from './MainLayout.module.scss';
import Sidebar from '@/admin/components/Sidebar/Sidebar';
import Header from '@/admin/components/Header/Header';
import clsx from 'clsx';
import SettingsModal from '@/admin/components/SettingsModal/SettingsModal';
import Footer from '@/components/Footer/Footer';

const MainLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const mainContentRef = useRef<HTMLDivElement>(null);

  useScrollToTop(mainContentRef);

  const openSettings = useCallback(() => setIsSettingsOpen(true), []);
  const closeSettings = useCallback(() => setIsSettingsOpen(false), []);

  return (
    <div className={styles.layout}>
      <Sidebar isCollapsed={isSidebarCollapsed} onToggleCollapse={setIsSidebarCollapsed} />
      <div className={clsx(styles.contentArea, { [styles.sidebarCollapsed]: isSidebarCollapsed })}>
        <Header
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={setIsSidebarCollapsed}
          onOpenSettings={openSettings}
        />
        <div ref={mainContentRef} className={styles.mainContent}>
          <main className={styles.content}>
            <Outlet />
          </main>
          <Footer />
        </div>
      </div>
      <SettingsModal show={isSettingsOpen} onClose={closeSettings} />
    </div>
  );
};

export default MainLayout;
